import React, { useState, FC } from 'react';

import {
  TableContainer, Table, TableHead, TableRow, TableCell,
  TableBody, makeStyles, Button, Select, MenuItem,
} from '@material-ui/core';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

interface CatalogSpecListProps {
  catalogSpecs: any[],
  onEdit: (catalogSpecId: string) => void,
}

const CatalogSpecList: FC<CatalogSpecListProps> = (props) => {
  const classes = useStyles();
  const [catalogSpecId, setCatalogSpecId] = useState('');
  const { catalogSpecs, onEdit } = props;

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Catalog</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              <Select
                labelId="catalogspec"
                id="catalogspec"
                value={catalogSpecId}
                onChange={(event) => setCatalogSpecId(event.target.value as string)}
              >
                { catalogSpecs?.map((cs: any, index: number) => (
                  <MenuItem key={`${index + 1}`} value={cs.id}>{cs.name}</MenuItem>)) }
              </Select>
            </TableCell>
            <TableCell>
              <Button
                variant="contained"
                onClick={() => {
                  onEdit(catalogSpecId);
                }}
              >
                Edit
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CatalogSpecList;
